import type { ReactNode } from 'react'
import { cx } from './shared'

/**
 * Separates the process glyph (what pipes connect to) from readouts/tags.
 *
 * - `port` (default): glyph centered on the parent lattice point (`<At>`);
 *   chrome absolutely parked below so it never shifts the port.
 * - `stack`: normal document flow for gallery / standalone use.
 */
export function PidNode({
  glyph,
  children,
  className,
  glyphHeight = 56,
  mode = 'port'
}: {
  glyph: ReactNode
  children?: ReactNode
  className?: string
  glyphHeight?: number
  mode?: 'port' | 'stack'
}) {
  return (
    <div className={cx('pid-node', mode === 'stack' && 'pid-node-stack', className)}>
      <div className="pid-glyph">{glyph}</div>
      {children ? (
        <div
          className="pid-chrome"
          style={mode === 'port' ? { top: glyphHeight / 2 + 6 } : undefined}
        >
          {children}
        </div>
      ) : null}
    </div>
  )
}
